import { KeyedResource } from './keyed.resource';

export class DocumentResource extends KeyedResource {
  private fieldNameImpl: string;

  constructor(args: any, pageName: string) {
    super(args, args.fieldName);

    const self: any = this;

    self.resourceType = 'document';
    self.fieldNameImpl = this.uiResourceName;
  }

  public get fieldName() {
    return this.fieldNameImpl;
  }
}
